module.exports = __webpack_public_path__ + "img/courseInfo.a7c3d1b5.jpg";